module.exports = __webpack_public_path__ + "img/zhihu.881166d9.png";